import { createAsyncThunk } from '@reduxjs/toolkit'
import WatchingPreviewProfileMetric from './watching-preview-profile-metric-model'
import {
  delete_watchingPreviewProfileMetric,
  load_watchingPreviewProfileMetrics,
  store_watchingPreviewProfileMetric,
} from './watchingPreviewProfileMetric-service'

export const LoadWatchingPreviewProfileMetricsAsync = createAsyncThunk<
  any,
  any
>(
  'composer/load/watchingPreviewProfileMetric',
  async (params: { uid: string }) => {
    return await load_watchingPreviewProfileMetrics(params)
  },
)

export const CreateWatchingPreviewProfileMetricAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/watchingPreviewProfileMetric',
  async (params: WatchingPreviewProfileMetric) => {
    return await store_watchingPreviewProfileMetric(params)
  },
)

export const DeleteWatchingPreviewProfileMetricAsync = createAsyncThunk<
  any,
  any
>('composer/delete/watchingPreviewProfileMetric', async (params) => {
  return await delete_watchingPreviewProfileMetric(params)
})
